import { inject, Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { DialogConfirmComponent } from '@shared/components';
import { DialogConfirmOptions } from '@shared/models';

@Injectable({
  providedIn: 'root'
})
export class ConfirmModalService {
  private readonly modalService = inject(BsModalService);

  confirmModal(options?: DialogConfirmOptions) {
    const modalRef: BsModalRef<DialogConfirmComponent> = this.modalService.show(
      DialogConfirmComponent,
      {
        initialState: { options }
      }
    );

    return new Observable<boolean>((observer) => {
      const sub = modalRef.onHidden?.subscribe(() => {
        observer.next(!!modalRef.content?.result);
        observer.complete();
      });

      return () => sub?.unsubscribe();
    });
  }
}
